import Button from '@/components/UI/Button';
import Card from '@/components/UI/Card/index.tsx';
import Table from '@/features/ChangeOrder/Summary/Table';
import { mockProgramReports } from '@/features/projects/components/Reports/data';
import { columns } from './columns';

export function Reports() {
  return (
    <Card title='Reports' titleElement={<Button btnStyle='btn-primary' label='Add New' />}>
      <Table tableClassName='!w-full' wrapperClassName='overflow-visible' cols={columns} data={mockProgramReports} />
    </Card>
  );
}
